import ReactGA from "react-ga4";

export const logPageView = (title = "") => {
  try {
    // console.log(process.env.REACT_APP_GA_TRACKING_ID);
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title,
    });
  } catch (error) {
    // console.log(error);
  }
};

export const logEvent = (category = "", action = "", label = "", value = 0) => {
  // console.log(process.env.REACT_APP_GA_TRACKING_ID);
  try {
    value = Number(value) || 0;
    if (category && action && label && value) {
      ReactGA.event({ category, action, label, value });
      // console.log({ category, action, label, value });
    }
  } catch (error) {
    // console.log(error);
  }
};
